import React, { Component } from "react";

export default class TextAreaInput extends Component {
  render() {
    return (
      <div className="text-area-input fieldContainer">
        <div className="topFieldContainer">
          <div className="form-group">
            <label
              className={this.props.hasError ? "is-invalid-label" : undefined}
              htmlFor={this.props.inputId}
            >
              {this.props.label}
            </label>
            <textarea
              className={
                "form-control text-area-input-field" +
                (this.props.hasError ? " is-invalid" : " is-valid")
              }
              name={this.props.inputId}
              id={this.props.inputId}
              rows={this.props.rows}
              cols={this.props.cols}
              onChange={event => {
                this.props.onChange({
                  target: {
                    name: this.props.inputId,
                    value: event.target.value
                  }
                });
              }}
              disabled={this.props.disabled}
              value={this.props.inputValue}
            >
              {this.props.inputValue}
            </textarea>
          </div>
        </div>
      </div>
    );
  }
}
